import { v4 } from 'uuid';
import { useZstdDocWrite } from '../common/useZstdDocWrite';
import { useApiCtgryMppng } from './useApiCtgryMppng';
import { ISsqDataDocumentAdminPopup, IVersion } from 'repositories/SsqDataRepository';

export type CopyDoc = {
  copyid: string;
  doc: ISsqDataDocumentAdminPopup;
  inputVer: IVersion;
};

export const useCopyDoc = (): { makeDoc: (p: { toLang: string }) => Promise<{ copyid: string }> } => {
  const { inputDoc, inputVer } = useZstdDocWrite();

  const api = useApiCtgryMppng();
  const makeDoc = ({ toLang }: { toLang: string }) => {
    return new Promise<{ copyid: string }>(async (resolve, reject) => {
      const copyid = v4();
      const doc = { ...inputDoc };
      // 1. 버전 정리할 것.
      doc.versions = (doc.versions || []).map((version) => {
        return {
          ...version,
          id: undefined,
          files: (version.files || []).map((file) => {
            return {
              ...file,
              id: 0,
            };
          }),
        };
      });
      // 2. 카테고리 변환할 것. ( 연결된 카테고리를 찾차서 매핑처리함. )
      const ctgryMppngs = await api(doc.categories.filter((ele) => ele > 0));
      doc.categories = ctgryMppngs.filter((ele) => ele.lang === toLang).map((ele) => ele.ctgryId);

      doc.id = undefined;
      doc.exposeSiteLanguage = toLang;

      // 3. inputVer 처리.
      const ver = { ...inputVer };
      ver.id = undefined;
      ver.files = (ver.files || []).map((file) => {
        return {
          ...file,
          id: 0,
        };
      });
      const copyDoc: CopyDoc = {
        copyid,
        doc,
        inputVer: ver,
      };
      sessionStorage.setItem('copydoc', JSON.stringify(copyDoc));
      resolve({ copyid });
    });
  };

  return {
    makeDoc,
  };
};
